import React, { useEffect, useState } from "react";
import { Field } from "redux-form";
import {
  renderTextField,
  renderTextFieldPreValue,
  renderOptionField,
} from "../formcomponents";
import { Table, Button, Grid } from "semantic-ui-react";

const SpendMoneyFieldArr = ({
  fields,
  totalAmountget,
  itemCategory,
  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    fields.push();
  }, []);
  const [total, setTotal] = useState([]);
  const [taxRate, settaxRate] = useState([]);
  const [finalAmount, setFinalAmount] = useState([]);
  const [unitPrice, setUnitPrice] = useState([]);
  const [quantity, setQuantity] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  const [selectedCurrency, setselectedCurrency] = useState("AED");
  const currencyOption = [
    { text: "AED", value: "AED" },
    { text: "EUR", value: "EUR" },
    { text: "USD", value: "USD" },
    { text: "INR", value: "INR" },
  ];

  const currencyConversion = [
    { option: "AED", value: 1 },
    { option: "EUR", value: 3.93 },
    { option: "USD", value: 3.67 },
    { option: "INR", value: 22.59 },
  ];
  const calculateTotal = (index, label, value) => {
    if (label === "quantity") {
      setQuantity((prevQuantity) => {
        const newQuantity = [...prevQuantity];
        newQuantity[index] = value;
        return newQuantity;
      });
    } else if (label === "unitPrice") {
      setUnitPrice((prevUnitPrice) => {
        const newUnitPrice = [...prevUnitPrice];
        newUnitPrice[index] = value;
        return newUnitPrice;
      });
    } else if (label === "discount") {
      setDiscount((prevDiscount) => {
        const newDiscount = [...prevDiscount];
        newDiscount[index] = value;
        return newDiscount;
      });
    } else if (label === "taxRate") {
      settaxRate((prevtaxRate) => {
        const newTaxRate = [...prevtaxRate];
        newTaxRate[index] = value;
        return newTaxRate;
      });
    } else if (label === "currency") {
      setselectedCurrency(value);
    }
  };

  useEffect(() => {
    const tempTotal = quantity.map((qty, index) => {
      const price = unitPrice[index] || 0;
      return qty * price;
    });

    setTotal(tempTotal);
  }, [quantity, unitPrice]);

  useEffect(() => {
    const calculatedFinalAmount = total.map((amount, index) => {
      const disc = discount[index] || 0;
      // const discountAmount = amount * (disc / 100);
      // return amount - discountAmount;
      return Number(amount) + Number(disc);
    });
    // setTotal(calculatedFinalAmount);

    const sum = calculatedFinalAmount.reduce(
      (accumulator, value) => accumulator + value,
      0
    );

    const currency = currencyConversion.find(
      (item) => item.option === selectedCurrency
    );

    const covertAmount = sum * currency.value;
    setTotalAmount(covertAmount);
    setFinalAmount([covertAmount]);

    // console.log("discount", calculatedFinalAmount);
  }, [total, discount, selectedCurrency]);

  // useEffect(() => {
  //   const tempTaxTotal = finalAmount.map((amount, index) => {
  //     const taxratetemp = taxRate[index] || 0;
  //     return amount - taxratetemp;
  //   });
  //   setFinalAmount(tempTaxTotal);
  // }, [taxRate]);

  useEffect(() => {}, [finalAmount]);
  return (
    <>
      {/* <p>{itemCategory}</p> */}

      {fields.map((item, index) => (
        <>
          <Grid.Row>
            <Grid columns="five">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={`${item}.itemName`}
                    type="text"
                    label="Item"
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.itemDescription`}
                    type="text"
                    label="Description"
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.itemQty`}
                    type="text"
                    label="Qty"
                    onChange={(e) =>
                      calculateTotal(index, "quantity", e.target.value)
                    }
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.unitPrice`}
                    type="text"
                    label="Unit Price"
                    onChange={(e) =>
                      calculateTotal(index, "unitPrice", e.target.value)
                    }
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.currency`}
                    label="Currency"
                    options={currencyOption}
                    onChange={(e) => calculateTotal(index, "currency", e)}
                    component={renderOptionField}
                  />{" "}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <Grid columns="four">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={`${item}.acccount`}
                    type="text"
                    label="Account"
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.taxRate`}
                    type="text"
                    label="Tax Rate"
                    onChange={(e) =>
                      calculateTotal(index, "discount", e.target.value)
                    }
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.region`}
                    type="text"
                    label="Purchase"
                    component={renderTextField}
                  />{" "}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.amount`}
                    type="text"
                    label="Amount AED"
                    fieldValue={finalAmount[index] || 0}
                    component={renderTextFieldPreValue}
                  />{" "}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          {/* <Grid.Row>
            <Grid columns="four">
              <Grid.Row>
                <Grid.Column></Grid.Column>
                <Grid.Column></Grid.Column>
                <Grid.Column>Total</Grid.Column>
                <Grid.Column>
                  {totalAmountget !== "" ? totalAmountget : totalAmount}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row> */}
        </>
      ))}
    </>
  );
};

export default SpendMoneyFieldArr;

// {totalAmountget !== "" ? totalAmountget : totalAmount}
